module.exports = __webpack_public_path__ + "img/Table.12b736c1.svg";